import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const setSelectedFileTypeReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<number>) => {
    state.selectedFileType = action.payload;
    state.pageNumber = 1;
    state.contentMarkedForDeletion = {};
  });
};

export default setSelectedFileTypeReducer;
